import { Moon, Sun } from "lucide-react"
import { useTheme } from "./theme-provider"
import { SidebarMenuButton, SidebarMenuItem } from "./ui/sidebar"

export function ModeToggle() {
  const { theme, setTheme } = useTheme()

  const toggleTheme = () => {
    if (theme === "light") {
      setTheme("dark")
    } else if (theme === "dark") {
      setTheme("light")
    } else {
      const isSystemDark = window.matchMedia("(prefers-color-scheme: dark)").matches
      setTheme(isSystemDark ? "light" : "dark")
    }
  }

  const isDark = theme === "dark" || (theme === "system" && window.matchMedia("(prefers-color-scheme: dark)").matches)

  return (
    <SidebarMenuItem>
      <SidebarMenuButton 
        onClick={toggleTheme}
        className="w-full flex items-center group cursor-pointer hover:bg-muted"
        title="Toggle Theme"
      >
        <div className="flex items-center gap-2">
          {isDark ? (
            <Moon className="h-4 w-4" />
          ) : (
            <Sun className="h-4 w-4" />
          )}
          <span className="font-medium">Toggle Theme</span>
        </div>
      </SidebarMenuButton>
    </SidebarMenuItem>
  )
}
